/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_TitleInputs */



/**
* | output |
* | --- |
* | "Compare Event Groups" |
*
* @param {Compare_Event_Groups_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_title = /** @type {((inputs?: Compare_Event_Groups_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comparer les groupes d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsgruppen vergleichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confronta gruppi di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сравнение групп событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comparar grupos de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("比较事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループを比較する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूहों की तुलना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comparar grupos de eventos")
	return /** @type {LocalizedString} */ ("Compare Event Groups")
});